export const setCopiedCaseNote = copiedCaseNote => dispatch => {
    dispatch({
        type: "UPDATE_COPIED_CASE_NOTE",
        payload: { copiedCaseNote }
    });
};
